<template>
	<c-dialog ref="dialog" title="分润退货详情" mode="slide" width="1000" enable-flex mask-close>
		<template #head>
			<div class="m-detail-tag flex-center-cross">
				<label class="return-code">{{detailData.return_code || '-'}}</label>
				<c-state tag dict="PROFIT_RETURN_STATE" :value="detailData.return_state"></c-state>
			</div>
		</template>

		<div class="m-detail-body">
			<c-title>单据信息</c-title>
			<div class="m-head-grid">
				<div class="head-item"><label>退货方向</label><span>{{headDirection}}</span></div>
				<div class="head-item"><label>对方商户</label><span>{{detailData.merchant_name || '-'}}</span></div>
				<div class="head-item"><label>退货数量</label><span>{{detailData.return_qty || 0}}</span></div>
				<div class="head-item"><label>快递单号</label><span>{{detailData.express_no || '-'}}</span></div>
				<div class="head-item"><label>创建人</label><span>{{detailData.create_user_name || '-'}}</span></div>
				<div class="head-item"><label>创建时间</label><span>{{detailData.create_date || '-'}}</span></div>
				<div class="head-item"><label>接收人</label><span>{{detailData.receive_user_name || '-'}}</span></div>
				<div class="head-item"><label>接收时间</label><span>{{detailData.receive_date || '-'}}</span></div>
				<div class="head-item"><label>货款结算人</label><span>{{detailData.supplier_contact_realname || '-'}}</span></div>
				<div class="head-item"><label>备注</label><span>{{detailData.remark || '-'}}</span></div>
			</div>

			<!--退款结算信息：退货完成后货款（按成本价）从货款结算人电子账户转出；展示退款金额与转账进度-->
			<c-title>退款结算信息</c-title>
			<div class="m-settle-bar">
				<div class="settle-item">
					<label>退款金额</label>
					<span class="z-refund">¥{{formatAmount(detailData.refund_amount)}}</span>
					<span :class="refundTransferClass">{{refundTransferText}}</span>
				</div>
			</div>

			<c-title>退货产品明细</c-title>
			<c-table ref="productTable" :data="productList" border :paging="false">
				<template #empty>
					<c-empty message="暂无产品明细"></c-empty>
				</template>
				<c-table-column label="产品信息" width="400">
					<template #default="{data}">
						<m-product-info :name="data.product_info" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
					</template>
				</c-table-column>
				<!-- <c-table-column label="新背贴码" width="150">
					<template #default="{data}">{{data.produce_unique_code || '-'}}</template>
				</c-table-column>
				<c-table-column label="原背贴码" width="150">
					<template #default="{data}">{{data.source_produce_unique_code || '-'}}</template>
				</c-table-column> -->
				<c-table-column label="原调拨单号" width="150">
					<template #default="{data}">{{data.transfer_code || '-'}}</template>
				</c-table-column>
				<c-table-column label="成本价" width="90">
					<template #default="{data}">{{data.cost_price ? '¥' + data.cost_price : '-'}}</template>
				</c-table-column>
			</c-table>
		</div>

		<template #button>
			<c-button v-if="receiveMode && detailData.return_state == 1" size="dialog" color="main" @click="confirmReceive">确认退货接收</c-button>
			<c-button size="dialog" @click="$refs.dialog.close()">关闭</c-button>
		</template>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'profitReturnDetail',

		computed: {
			...mapState(['saasInfo', 'userInfo']),

			headDirection() {
				//方向由详情接口按当前商户视角返回（1我发起的退货，2退货给我的）
				if (this.detailData.direction == 2) {
					return (this.detailData.merchant_name || '对方') + ' → 本商户';
				}
				return '本商户 → ' + (this.detailData.merchant_name || '对方');
			},

			//退款转账进度：待转账(1,2)==0 且 已转账(3)>0 视为已转账
			refundTransferText() {
				var pending = Number(this.detailData.refund_pending_qty || 0);
				var settled = Number(this.detailData.refund_settled_qty || 0);
				if (pending == 0 && settled > 0) {
					return '（已转账）';
				}
				if (settled > 0 && pending > 0) {
					return '（部分转账）';
				}
				return '（未转账）';
			},

			refundTransferClass() {
				return this.refundTransferText == '（已转账）' ? 'z-transferred' : 'z-untransferred';
			}
		},

		data() {
			return {
				returnId: '',
				receiveMode: false,
				detailData: {},
				productList: []
			}
		},

		methods: {
			/*********打开抽屉（receiveMode=true 为退货接收）**********/
			open(id, receiveMode) {
				this.returnId = id;
				this.receiveMode = !!receiveMode;
				this.detailData = {};
				this.productList = [];
				this.loadDetail();
				this.$refs.dialog.open();
			},

			/*********加载详情**********/
			loadDetail() {
				this.request({
					url: '/profitTransferReturn/detail',
					data: {id: this.returnId},
					loading: true,
					success: data => {
						this.detailData = data || {};
						this.productList = (data && data.product_list) || [];
					}
				});
			},

			/*********金额展示（保留两位）**********/
			formatAmount(val) {
				return Number(val || 0).toFixed(2);
			},

			/*********确认退货接收（原码复活、新码归档）**********/
			confirmReceive() {
				this.$confirm({
					message: '确认接收退货单【' + (this.detailData.return_code || '') + '】？接收后原背贴码将复活在库，不可撤销！',
					buttonName: '确定接收',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/profitTransferReturn/receive/confirm',
							data: {id: this.returnId},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '退货接收成功', type: 'success'});
								this.$refs.dialog.close();
								this.$emit('resolve');
							},
							fail: (code, data, msg) => {
								this.$message({message: msg, type: 'error'});
								return false;
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-tag {
		gap: 10px;

		.return-code {
			font-size: 13px;
			color: #666;
		}
	}

	.m-detail-body {
		padding: 0 16px;
	}

	.m-head-grid {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;

		.head-item {
			width: 33.33%;
			padding: 6px 0;
			font-size: 13px;

			label {
				color: #999;
				margin-right: 8px;
			}

			span {
				color: #333;
			}
		}
	}

	.m-settle-bar {
		display: flex;
		flex-wrap: wrap;
		gap: 24px;
		padding: 10px 12px;
		margin-bottom: 12px;
		background: #fafafa;
		border-radius: 4px;

		.settle-item {
			display: flex;
			align-items: center;
			font-size: 13px;

			label {
				color: #999;
				margin-right: 8px;
			}

			.z-refund {
				color: #fa8c16;
				font-size: 16px;
				font-weight: bold;
				margin-right: 6px;
			}
		}
	}

	.z-transferred {
		color: #52c41a;
	}

	.z-untransferred {
		color: #f5222d;
	}
</style>
